/**
 * Created by vtbelo on 17/03/21
 */

const PixelView = cc.Node.extend({
    ctor: function (pixel) {
        this._super();
        this.pixel = pixel;

        this.pixel.setView(this);

        const styles = this.getStyles();

        this.setAnchorPoint(0.5, 0.5);

        this.target = new cc.Node();
        this.target.setAlignment(styles.collect);
        this.addChild(this.target);
        const bundle = this.getPixelBundle();

        this.animation = new LazyAsset(bundle.jsons[`${this.pixel.type}_pixels_json`] || bundles.pixels.jsons["pixels_json"], {
            preview: this.pixel.type !== PixelsSwarm.FRIEND ? new cc.Sprite(bundles.merge.frames.pixel_preview) : undefined,
            onLoad: function () {
                if (this.pixel.type === PixelsSwarm.FRIEND) {
                    this.addFriendViews();
                }

                cleverapps.effects.fire("pixels.spawn");
            }.bind(this)
        });

        this.animation.setAnimation(0, "animation", true);
        this.setContentSize2(this.animation.getContentSize());
        this.animation.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.animation);
        if (styles.timeScale) {
            this.animation.setTimeScale(styles.timeScale.base + Math.random() * styles.timeScale.random);
        }

        cleverapps.UI.onDrag(this, {
            onClick: this.pixel.collect.bind(this.pixel),
            followPointer: true,
            onDragStart: function () {
                if (cleverapps.tutorial.checkConditions({ pixel: this.pixel.type })) {
                    return false;
                }
                this.pixel.setFlying(false);
                this.setLocalZOrder(1);

                return true;
            }.bind(this),
            onDragEnd: function () {
                this.pixel.setFlying(true);
                this.setLocalZOrder(0);
            }.bind(this),
            filter: function () {
                return Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial && !Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial && cleverapps.tutorial.isActive();
            }
        });

        this.pixel.onFlyingChanged = this.createListener(this.changeFlying.bind(this));
        this.pixel.onAnimateCollect = this.createListener(this.collect.bind(this));
        this.pixel.onStartTutorial = this.createListener(this.startTutorialAnimation.bind(this));
        this.pixel.onDie = this.createListener(this.explode.bind(this));

        this.minFlyTime = cleverapps.parseInterval(PixelView.FLY_TIME);

        const cell = Map2d.currentMap.getMapView().alignInGrid(this.pixel.x, this.pixel.y);
        this.setPosition(cell.x, cell.y);

        this.speed = styles.speed;
        this.distanceDisappear = styles.distanceDisappear;

        Map2dLocation.currentLocation.pushingComponent.add(this, "pixels");

        if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial) {
            Map2dLocation.currentLocation.tutorial.on("showTutorialStep", this.createListener(this.changeFlying.bind(this, false)));
            Map2dLocation.currentLocation.tutorial.on("finishTutorialStep", this.createListener(this.changeFlying.bind(this, true)));
        }

        cleverapps.tutorial.on("nextTutorialStep", this.createListener(this.changeFlying.bind(this, false)));
        cleverapps.tutorial.on("finishTutorial", this.createListener(this.changeFlying.bind(this, true)));

        this.flyStartTime = Date.now();
        this.pixel.setFlying(true);

        this.runAction(StandartAnimations.showUp(this, { flash: true }));
        this.lastCheck = 0;
    },

    getPixelBundle: function () {
        let bundle = bundles.pixels;
        if (this.pixel.type === PixelsSwarm.FRIEND) {
            bundle = bundles.pixels_friends;
        } else if (this.pixel.type === PixelsSwarm.ENERGY) {
            bundle = bundles.pixels_energy;
        } else if (this.pixel.type === PixelsSwarm.COINS) {
            bundle = bundles.pixels_coin;
        } else if (this.pixel.type === PixelsSwarm.ADS) {
            bundle = bundles.pixels_ad;
        }
        return bundle;
    },

    startTutorialAnimation: function (callback) {
        callback = callback || function () {};
        const centerPosition = Map2d.currentMap.getMapView().alignInGrid(Map2d.currentMap.scroller.scrollCell.x, Map2d.currentMap.scroller.scrollCell.y);

        this.setVisible(false);
        this.runAction(
            new cc.Sequence(
                new cc.DelayTime(1),
                new cc.MoveTo(2, centerPosition).easing(cc.easeInOut(2)),
                new cc.CallFunc(callback)
            )
        );
    },

    addAvatar: function (avatar, userId) {
        if (this.avatar) {
            this.avatar.removeFromParent();
        }

        this.avatar = new cleverapps.UI.Avatar(avatar, {
            userId,
            frame: bundles.avatar.frames.avatar_frame2
        });

        const styles = this.getStyles();
        this.avatar.setLocalZOrder(1);
        this.avatar.setAlignment(styles.avatar.position);
        cleverapps.UI.fitToBox(this.avatar, styles.avatar);
        this.addChild(this.avatar);
    },

    addFriendViews: function () {
        const friend = cleverapps.friends.getById(this.pixel.friendRequest.from);
        if (friend) {
            this.addAvatar(friend);
        } else {
            this.addAvatar(undefined, this.pixel.friendRequest.from);
        }

        const styles = this.getStyles();

        if (this.pixel.friendRequest && this.pixel.friendRequest.id !== "tutorialpixel") {
            const message = this.message = new cc.Node();
            message.setAnchorPoint(0.5, 0.5);
            message.setContentSize2(styles.message.width, styles.message.height);
            message.setAlignment(styles.message.position);
            message.setLocalZOrder(1);
            this.addChild(message);

            const bg = cleverapps.UI.createScale9Sprite(bundles.dialogues_minimal.frames.bg_minimal_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
            bg.setContentSize2(message.width / 0.3, message.height / 0.3);
            bg.setAlignment(message.width / 2, message.height / 2);
            bg.setScale(0.3);
            message.addChild(bg);

            const bgArrow = new cc.Sprite(bundles.dialogues_minimal.frames.mini_arrow_bg_png);
            bgArrow.setAlignment(styles.message.arrow.position);
            bgArrow.setAnchorPoint(0.5, 0);
            bgArrow.setScale(0.3);
            bgArrow.setRotation(-90);
            message.addChild(bgArrow);

            const text = cleverapps.UI.generateOnlyText(Messages.get("Pixels.friend"), {
                size: 60,
                color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
            });
            text.setAlignment(styles.message.text.position);
            cleverapps.UI.fitToBox(text, styles.message.text);
            message.addChild(text);
        }

        if (cleverapps.config.debugMode) {
            this.debugText = cleverapps.UI.generateOnlyText(this.pixel.friendRequest.from, {
                size: 30,
                color: cleverapps.styles.COLORS.WHITE
            });

            this.addChild(this.debugText);
            this.debugText.setAlignment(styles.debugText.position);
        }
    },

    getStyles: function () {
        return cleverapps.skins.getSlot("pixelViewType", this.pixel.type) || cleverapps.styles.PixelView[this.pixel.type] || cleverapps.styles.PixelView;
    },

    update: function (dt) {
        this.setPosition(this.x + this.speed.x * dt, this.y + this.speed.y * dt);
        const screenSize = cleverapps.resolution.getBgSize();

        const ct = Date.now();
        if (this.flyStartTime + this.minFlyTime < ct && this.lastCheck < ct - 3000) {
            this.lastCheck = ct;
            const pos = this.parent.convertToWorldSpace(this.getPosition());

            if (screenSize.width + this.distanceDisappear < pos.x || pos.y < -this.distanceDisappear) {
                this.pixel.die(true);
            }
        }

        const onScreen = cc.rectIntersectsRect(this.animation.getGlobalBoundingBox(), cc.rect(0, 0, screenSize.width, screenSize.height));
        const lastScrollTime = Map2d.currentMap && Map2d.currentMap.lastScrollTime || 0;

        if (onScreen || lastScrollTime + 500 < cleverapps.timeouts.time) {
            this.setVisible(onScreen);
        }
    },

    changeFlying: function (flying) {
        if (flying) {
            this.scheduleUpdate();
            this.resumePushing();
        } else {
            this.unscheduleUpdate();
            this.pausePushing();
        }
    },

    collect: function (callback) {
        const styles = this.getStyles().collect;

        callback({
            source: this.target,
            delay: styles.delay,
            effect: [`pixels.collect.${this.pixel.type}`, "pixels.collect"]
        });
    },

    explode: function (silent) {
        cleverapps.pointerManager.removeAll(this);

        if (this.avatar) {
            this.avatar.removeFromParent();
        }

        if (this.message) {
            this.message.removeFromParent();
        }

        const callback = cleverapps.once(() => {
            this.removeFromParent();
        });

        if (this.animation.isLoaded()) {
            this.animation.setAnimation(0, "animation2", false);
            this.animation.setCompleteListener(callback);
        } else {
            const delay = this.getStyles().collect.delay * 0.001 || 0;
            this.animation.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.ScaleTo(0.1, 0.3),
                new cc.Hide(),
                new cc.CallFunc(callback)
            ));
        }

        if (silent) {
            callback();
        }
    }
});

PixelView.FLY_TIME = "90 seconds";

cleverapps.styles.PixelViewTemplate = {
    distanceDisappear: 1000,
    speed: { x: 35, y: -18 },
    collect: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 },
        delay: 150
    }
};

cleverapps.styles.PixelView = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {}, true);

cleverapps.styles.PixelView[PixelsSwarm.FRIEND] = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {
    collect: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -350 },
        delay: 1450
    },

    avatar: {
        width: 80,
        height: 80,
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 18 }
        }
    },
    message: {
        width: 150,
        height: 50,

        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 75 }
        },

        arrow: {
            width: 60,
            height: 60,
            position: {
                x: { align: "center", dx: 10 },
                y: { align: "bottom", dy: 0 }
            }
        },

        text: {
            width: 120,
            height: 45,
            position: {
                x: { align: "center" },
                y: { align: "center" }
            }
        }
    },
    debugText: {
        position: {
            x: { align: "center" },
            y: { align: "top", dy: 30 }
        }
    }
}, true);